// ============================================================================
// Icônes Orgazone — rendu DOM (<svg>) du registre PARTAGÉ `ui-tokens/icons`. Pendant exact de
// `ui-native/icons` : mêmes noms, mêmes dessins, même API — un nom = un seul dessin partout
// (fin des trois `grid` différents selon l'app, audit D10 CADRAGE-Alignement-UI).
// ============================================================================
import { ICONS, ICON_DEFAULTS, type IconName } from '@orgazone/ui-tokens';

export type { IconName };

export interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  stroke?: number;
  style?: React.CSSProperties;
}

export function Icon({ name, size = 20, color = 'currentColor', stroke = ICON_DEFAULTS.stroke, style }: IconProps) {
  const prims = ICONS[name];
  if (!prims) return null;
  return (
    <svg width={size} height={size} viewBox={`0 0 ${ICON_DEFAULTS.viewBox} ${ICON_DEFAULTS.viewBox}`} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" aria-hidden style={style}>
      {prims.map((pr, i) => {
        if (pr[0] === 'p') return <path key={i} d={pr[1]} strokeOpacity={pr[2]} />;
        if (pr[0] === 'r') return <rect key={i} x={pr[1]} y={pr[2]} width={pr[3]} height={pr[4]} rx={pr[5]} />;
        return <circle key={i} cx={pr[1]} cy={pr[2]} r={pr[3]} />;
      })}
    </svg>
  );
}
